import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { FileText } from "lucide-react";

import { api } from "@/lib/api";
import { BackHeader } from "@/components/back-header";
import { PolicyFooter } from "@/components/policy-footer";
import { EmptyState, Loading } from "@/components/ui";

/** Public policy pages (no login). Content is managed by admins in the DB (Admin → Content). */
export default function Legal({ docKey }) {
  const params = useParams();
  const doc = (docKey ?? params.doc ?? "").replace("-", "_");
  const { data: d, isLoading } = useQuery({ queryKey: ["legal", doc], queryFn: () => api(`/legal/${doc}`, { auth: false }), retry: false });
  return (
    <div className="min-h-screen bg-background" data-testid={`legal-screen-${doc}`}>
      <div className="mx-auto max-w-3xl px-6 py-8">
        <BackHeader title={d?.title ?? (isLoading ? "" : "Not found")} fallback="/" />
        {isLoading ? <Loading /> : d ? (
          <article className="fade-up">
            <p className="mb-8 text-xs text-muted-foreground" data-testid="legal-updated">Last updated {d.updated}</p>
            {d.sections.map((s, i) => (
              <section key={`${s.h}-${i}`} className="mb-8">
                <h2 className="mb-1 text-[24px]">{s.h}</h2>
                <p className="whitespace-pre-line text-[15px] leading-[23px]">{s.p}</p>
              </section>
            ))}
          </article>
        ) : <EmptyState testId="legal-not-found" icon={FileText} title="Page not found" />}
        <PolicyFooter prefix="legal-footer" />
      </div>
    </div>
  );
}
